@if(formGroup) {
  <form [formGroup]="formGroup" (ngSubmit)="save()">
    <dialog class="bm-modal" open (document:keydown.escape)="closeModal.emit()">
      <div class="bm-modal-box max-h-[80vh] overflow-y-auto w-full max-w-2xl p-6">
        <h4 class="text-lg font-bold">Mailtemplate bearbeiten</h4>

        <div class="bm-alert bm-alert-error bm-alert-soft my-2">
          <div>
            <h4 class="font-bold">HINWEIS</h4>
            <div  class="text-xs mb-2">Mailtemplates können den einzelnen Status des Projektes zugeordnet werden. Sobald ein solcher Status in einem Ticket erreicht wird, wird eine Mail an die hinterlegten Kontakte des Projektes gesendet.</div>
            <div  class="text-xs mb-2">Hier können Sie diese Mailbenachrichtigung anpassen, insbesondere können Sie festlegen welche Daten des Tickets mit in der Mail versendet werden sollen.</div>
          </div>
        </div>

        <fieldset class="bm-card bm-card-sm bm-fieldset px-0">
          <legend  class="bm-fieldset-legend">Mailtemplate</legend>
          <label class="bm-fieldset-label">Template-Typ*</label>
          <select class="bm-select" formControlName="type">
            <option value="STATUS_CHANGED">STATUS_CHANGED</option>
            <option value="OPERATION_NEW">OPERATION_NEW</option>
            <option value="OPERATION_UPDATE">OPERATION_UPDATE</option>
            <option value="OPERATION_DELETE">OPERATION_DELETE</option>
            <option value="OPERATION_SUMMARY">OPERATION_SUMMARY</option>
            <option value="DEADLINE_1">DEADLINE_1</option>
            <option value="DEADLINE_1_SMS">DEADLINE_1_SMS</option>
            <option value="DEADLINE_2">DEADLINE_2</option>
            <option value="DEADLINE_2_SMS">DEADLINE_2_SMS</option>
            <option value="DEADLINE_3">DEADLINE_3</option>
            <option value="DEADLINE_3_SMS">DEADLINE_3_SMS</option>
            <option value="TASK_DEADLINE">TASK_DEADLINE</option>
            <option value="TASK_DEADLINE_SMS">TASK_DEADLINE_SMS</option>
          </select>

          <label class="bm-fieldset-label">Betreff*</label>
          <input type="text" class="bm-input" formControlName="subject">

          <label class="bm-fieldset-label">Text*</label>
          <textarea class="bm-textarea" formControlName="text"></textarea>
          <span>
            Im Betreff und im Text können Sie folgende Platzhalter verwenden: <code>{{"${ticket.orderNr} ${ticket.status} ${ticket.priority} ${ticket.externalOrderNr} ${ticket.description}"}}</code>
          </span>
        </fieldset>

        <fieldset class="bm-card bm-card-sm bm-fieldset px-0">
          <legend class="bm-fieldset-legend">Ticketfelder</legend>

          <label class="bm-fieldset-label">Daten</label>
          <div class="flex flex-row flex-wrap gap-2">
            <label class="bm-label">
              <input type="checkbox" class="bm-checkbox" formControlName="orderNr"/>
              Auftragsnummer
            </label>
            <label class="bm-label">
              <input type="checkbox" class="bm-checkbox" formControlName="status"/>
              Status
            </label>
            <label class="bm-label">
              <input type="checkbox" class="bm-checkbox" formControlName="reportLink"/>
              Link zum Arbeitsbericht
            </label>
            <label class="bm-label">
              <input type="checkbox" class="bm-checkbox" formControlName="dateSLA"/>
              SLA-Zeitpunkt
            </label>
            <label class="bm-label">
              <input type="checkbox" class="bm-checkbox" formControlName="operationDate"/>
              Einsatzzeitpunkt
            </label>
            <label class="bm-label">
              <input type="checkbox" class="bm-checkbox" formControlName="tasks"/>
              Aufgaben
            </label>
            <label class="bm-label">
              <input type="checkbox" class="bm-checkbox" formControlName="priority"/>
              Priorität
            </label>
            <label class="bm-label">
              <input type="checkbox" class="bm-checkbox" formControlName="dateCreated"/>
              Datum der Ticketerstellung
            </label>
            <label class="bm-label">
              <input type="checkbox" class="bm-checkbox" formControlName="externalOrderNr"/>
              Externe Nummer
            </label>
            <label class="bm-label">
              <input type="checkbox" class="bm-checkbox" formControlName="description"/>
              Fehlertext
            </label>
            <label class="bm-label">
              <input type="checkbox" class="bm-checkbox" formControlName="project"/>
              Projektname
            </label>
            <label class="bm-label">
              <input type="checkbox" class="bm-checkbox" formControlName="store"/>
              Store
            </label>
            <label class="bm-label">
              <input type="checkbox" class="bm-checkbox" formControlName="address"/>
              Adresse
            </label>
            <label class="bm-label">
              <input type="checkbox" class="bm-checkbox" formControlName="deliveryNotes"/>
              Lieferungen
            </label>
          </div>

          <label class="bm-fieldset-label">Kontakt</label>
          <div class="flex flex-row flex-wrap gap-2">
            <label class="bm-label">
              <input type="checkbox" class="bm-checkbox" formControlName="contactName"/>
              Name
            </label>
            <label class="bm-label">
              <input type="checkbox" class="bm-checkbox" formControlName="contactEmail"/>
              E-Mail
            </label>
            <label class="bm-label">
              <input type="checkbox" class="bm-checkbox" formControlName="contactPhone"/>
              Telefon
            </label>
          </div>
        </fieldset>

        <fieldset class="bm-card bm-card-sm bm-fieldset px-0">
          <legend class="bm-fieldset-legend">Einsatzdaten</legend>
          <label class="bm-fieldset-label">Daten</label>
          <div class="flex flex-row flex-wrap gap-2">
            <label class="bm-label">
              <input type="checkbox" class="bm-checkbox" formControlName="operation.date"/>
              Einsatzzeitpunkt
            </label>
            <label class="bm-label">
              <input type="checkbox" class="bm-checkbox" formControlName="operation.status"/>
              Status
            </label>
            <label class="bm-label">
              <input type="checkbox" class="bm-checkbox" formControlName="operation.technicians"/>
              Techniker
            </label>
            <label class="bm-label">
              <input type="checkbox" class="bm-checkbox" formControlName="operation.description"/>
              Beschreibung
            </label>
            <label class="bm-label">
              <input type="checkbox" class="bm-checkbox" formControlName="operation.report"/>
              Report
            </label>
          </div>
          <label class="bm-fieldset-label">Alt</label>
          <div class="flex flex-row flex-wrap gap-2">
            <label class="bm-label">
              <input type="checkbox" class="bm-checkbox" formControlName="operation.travelTimeStart"/>
              Fahrzeit Begin
            </label>
            <label class="bm-label">
              <input type="checkbox" class="bm-checkbox" formControlName="operation.travelTimeEnd"/>
              Fahrzeit Ende
            </label>
            <label class="bm-label">
              <input type="checkbox" class="bm-checkbox" formControlName="operation.travelTime"/>
              Fahrzeit
            </label>
            <label class="bm-label">
              <input type="checkbox" class="bm-checkbox" formControlName="operation.workingTimeStart"/>
              Arbeitszeit Begin
            </label>
            <label class="bm-label">
              <input type="checkbox" class="bm-checkbox" formControlName="operation.workingTimeEnd"/>
              Arbeitszeit Ende
            </label>
            <label class="bm-label">
              <input type="checkbox" class="bm-checkbox" formControlName="operation.workingTime"/>
              Arbeitszeit
            </label>
          </div>
          <label class="bm-fieldset-label">Neu</label>
          <div class="flex flex-row flex-wrap gap-2">
            <label class="bm-label">
              <input type="checkbox" class="bm-checkbox" formControlName="operation.dateTravelStart"/>
              Zeitpunkt: Reisebeginn
            </label>
            <label class="bm-label">
              <input type="checkbox" class="bm-checkbox" formControlName="operation.dateOnSite"/>
              Zeitpunkt: Vor Ort
            </label>
            <label class="bm-label">
              <input type="checkbox" class="bm-checkbox" formControlName="operation.dateRepaired"/>
              Zeitpunkt: Repariert
            </label>
            <label class="bm-label">
              <input type="checkbox" class="bm-checkbox" formControlName="operation.dateFinished"/>
              Zeitpunkt: Fertig
            </label>
          </div>
          <label class="bm-fieldset-label">Arbeitsbericht</label>
          <div class="flex flex-row flex-wrap gap-2">
            <label class="bm-label">
              <input type="checkbox" class="bm-checkbox" formControlName="operation.distance"/>
              Entfernung
            </label>
          </div>
        </fieldset>

        <fieldset class="bm-card bm-card-sm bm-fieldset px-0">
          <legend class="bm-fieldset-legend">Anhänge</legend>
          <p class="text-xs mb-2 px-4">
            Hier legen Sie fest, was zusätzlich zum Mailtext an den Kunden geht.
            Einsatzbericht und Ticket-Sammelbericht sind zwei verschiedene Dokumente und
            werden unabhängig voneinander gesteuert: sind beide gewählt, bekommt der Kunde
            auch beide.
          </p>
          <label class="bm-fieldset-label">Einsatzbericht (je Einsatz)</label>
          <div class="flex flex-row flex-wrap gap-4">
            @for (option of reportPdfOptionen; track option.wert) {
              <label class="bm-label">
                <input type="radio" class="bm-radio" formControlName="report_pdf" [value]="option.wert"/>
                {{ option.label }}
                <span class="text-xs opacity-70">{{ option.hinweis }}</span>
              </label>
            }
          </div>
          <label class="bm-fieldset-label">Ticket-Sammelbericht (je Ticket, Legacy-Format)</label>
          <div class="flex flex-row flex-wrap gap-2">
            <label class="bm-label">
              <input type="checkbox" class="bm-checkbox" formControlName="combined_report"/>
              Sammelbericht über alle Einsätze anhängen
            </label>
          </div>
          <label class="bm-fieldset-label">Dateien</label>
          <div class="flex flex-row flex-wrap gap-2">
            <label class="bm-label">
              <input type="checkbox" class="bm-checkbox" formControlName="operation.files"/>
              Alle Dateien des Arbeitsberichtes anhängen (Fotos usw.)
            </label>
          </div>
        </fieldset>

        <div class="bm-modal-action p-4 mt-0">
          <button class="bm-btn bm-btn-secondary" type="button" (click)="closeModal.emit()">Abbrechen</button>
          <button class="bm-btn bm-btn-primary" type="submit" [disabled]="!formGroup.valid">Speichern</button>
        </div>
      </div>
    </dialog>
  </form>
}
